module.exports = __webpack_public_path__ + "static/media/muted-hover.9001e5ad.svg";